module.exports = __webpack_public_path__ + "img/anzhuang.af1095ea.png";